<template>
  <div v-if="show" class="backend-link">
    <a :href="backendLink" target="_blank">Edit</a>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  path: string
}>()

const cookie = useCookie('admin', {
  maxAge: 60 * 60 * 24 * 365 * 10
})

let show = false
if (cookie.value && cookie.value !== null && cookie.value.toString() === '1') {
  show = true
}

const config = useRuntimeConfig()
const backendLink = `${config.public.serverUrl}${props.path}/edit`
</script>

<style lang="scss" scoped>
.backend-link {
  height: 0;
}
</style>
